import BaseModal from "components/BaseModal";
import { useSession } from "hooks/useSession";
import React from "react";
import { showMainToast } from "utils/showToast";

export default function UserFormModal({ show, onClose, mode, userData, onSuccess,userRole }) {
  console.log(userData);
  const { userid } = useSession();

  
  
  const canCreateApiPartner = userRole === "Admin" || userRole === "Main Admin";

  const handleSave = async () => {
    const name  = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const phone = document.getElementById("phone").value;
    const role  = document.querySelector('select[name="role"]').value;

    const formData = new FormData();
    formData.append("name",   name);
    formData.append("email",  email);
    formData.append("phone",  phone);
    formData.append("role",   role);
    formData.append("userid", userid);
    formData.append("action", "ADDUpdate");
    formData.append("id",     userData?.id || "");

    try {
      const response = await fetch("https://api.mokshiq.in/retailer_action", {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
        return;
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
        if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Member" : "Add Member"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        {
          label: mode === "edit" ? "Update" : "Save",
          className: "btn-primary",
          onClick: handleSave,
        },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          <div className="col-md-6">
            <label className="form-label" htmlFor="name">Name</label>
            <input
              className="form-control"
              id="name"
              name="name"
              type="text"
              defaultValue={userData?.name || ""}
            />
            <div className="mt-1"><span className="text-danger" id="userNameError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              className="form-control"
              id="email"
              type="email"
              defaultValue={userData?.email || userData?.Email || ""}
            />
            <div className="mt-1"><span className="text-danger" id="emailError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label" htmlFor="phone">Phone</label>
            <input
              className="form-control"
              id="phone"
              type="text"
              defaultValue={userData?.phone || userData?.Phone || ""}
            />
            <div className="mt-1"><span className="text-danger" id="phoneError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label">Role</label>
            <select
              className="form-select w-100"
              name="role"
              defaultValue={userData?.role || "5"}
            >
              <option value="5">Retailer</option>
              <option value="4">Distributor</option>
              <option value="3">Super Distributor</option>
              <option value="2">White label</option>
              {canCreateApiPartner && <option value="9">API Partner</option>}
            </select>
            <div className="mt-1"><span className="text-danger" id="roleError"></span></div>
          </div>
        </form>
      </div>
    </BaseModal>
  );
}